<template>
  <BaseSimpleModal :showHeader="false" useCustomFooter @backdropClick="$emit('close')" fitContent fullWidth
    modalClass="select-plan-modal" bodyClass="select-plan-modal-body" style="height:auto;">
    <div class="plans-content">
      <div class="plans-header">
        <div class="plans-header-titles">
          <div class="qrw-heading-lg bold qrw-text-content-base-primary">
            {{ $t('select_plan_modal.title') }}
          </div>
          <div class="qrw-paragraph-md qrw-text-content-base-tertiary">
            {{ $t('select_plan_modal.subtitle') }}
          </div>
        </div>

        <BaseSwitcherBar size="sm" tabWidth="160px"
          style="background: var(--qrw-background-base-tertiary); padding: 2px; border-radius: 10px" :tabs="[{
    text: $t('select_plan_modal.monthly'),
    value: 'monthly'
  }, {
    text: $t('select_plan_modal.annually') + ' (-20%)',
    value: 'yearly'
  }]" v-model="selectedPeriodicity" />
      </div>

      <div class="plans">
        <div class="plan-container">
          <div class="plan-hot hidden">
            <BaseIcon icon="fire-filled" size="sm2" />
            <div class="qrw-label-md bold">
              {{ $t('select_plan_modal.most_popular') }}
            </div>
          </div>
          <div class="plan-card" @click="selectPlan('lite')" :class="{
    selected: selectedPlan === 'lite'
  }">
            <div class="plan-card-body">
              <div class="plan-title qrw-heading-sm bold">
                Lite {{ $t('select_plan_modal.plan') }}
              </div>
              <div class="qrw-paragraph-lg qrw-text-content-base-tertiary">
                {{ $t('select_plan_modal.lite_desc') }}
              </div>
            </div>
            <div class="plan-card-footer" v-if="selectedPeriodicity == 'yearly'">
              <div class="qrw-heading-sm bold qrw-text-content-base-primary bold">
                $ {{ pricings.yearly.lite }} / {{ $t('select_plan_modal.year') }}
              </div>
              <div class="qrw-label-lg qrw-text-content-base-tertiary">
                $ {{ pricings.monthly.lite }} / {{ $t('select_plan_modal.month') }}
              </div>
            </div>
            <div class="plan-card-footer" v-else>
              <div class="qrw-heading-sm qrw-text-content-base-primary bold">
                $ {{ pricings.monthly.lite }} / {{ $t('select_plan_modal.month') }}
              </div>
            </div>
          </div>
          <div class="plan-badge qrw-label-md selected" v-if="selectedPlan == 'lite'">
            {{ $t('select_plan_modal.selected') }}
          </div>
          <div class="plan-badge qrw-label-md" @click="selectPlan('lite')" v-else>
            {{ $t('select_plan_modal.select') }}
          </div>
        </div>
        <div class="plan-container">
          <div class="plan-hot">
            <BaseIcon icon="fire-filled" size="sm2" />
            <div class="qrw-label-md bold">
              {{ $t('select_plan_modal.most_popular') }}
            </div>
          </div>
          <div class="plan-card" @click="selectPlan('dynamic')" :class="{
    selected: selectedPlan === 'dynamic'
  }">
            <div class="plan-card-body">
              <div class="plan-title qrw-heading-sm bold">
                Dynamic {{ $t('select_plan_modal.plan') }}
              </div>
              <div class="qrw-paragraph-lg qrw-text-content-base-tertiary">
                {{ $t('select_plan_modal.dynamic_desc') }}
              </div>
            </div>
            <div class="dynamic-config">
              <div class="config-row">
                <div class="config-row-title qrw-label-lg qrw-text-content-base-primary w-100">
                  Inside
                </div>
                <div class="config-row-title qrw-label-lg qrw-text-content-base-primary">
                  $ {{ pricings.services.inside }}
                </div>
                <BaseBetaToggle v-model="dynamicConfig.inside" size="xs" />
              </div>
              <BaseDivider color="border-base-tertiary" />
              <div class="config-row">
                <div class="config-row-title qrw-label-lg qrw-text-content-base-primary w-100">
                  Takeaway
                </div>
                <div class="config-row-title qrw-label-lg qrw-text-content-base-primary">
                  $ {{ pricings.services.takeaway }}
                </div>
                <BaseBetaToggle v-model="dynamicConfig.takeaway" size="xs" />
              </div>
              <BaseDivider color="border-base-tertiary" />
              <div class="config-row">
                <div class="config-row-title qrw-label-lg qrw-text-content-base-primary w-100">
                  Delivery
                </div>
                <div class="config-row-title qrw-label-lg qrw-text-content-base-primary">
                  $ {{ pricings.services.delivery }}
                </div>
                <BaseBetaToggle v-model="dynamicConfig.delivery" size="xs" />
              </div>
            </div>
            <div class="plan-card-footer" v-if="selectedPeriodicity == 'yearly'">
              <div class="qrw-heading-sm bold qrw-text-content-base-primary bold">
                $ {{ pricings.yearly.dynamic }} / {{ $t('select_plan_modal.year') }}
              </div>
              <div class="qrw-label-lg qrw-text-content-base-tertiary">
                $ {{ pricings.monthly.dynamic }} / {{ $t('select_plan_modal.month') }}
              </div>
            </div>
            <div class="plan-card-footer" v-else>
              <div class="qrw-heading-sm qrw-text-content-base-primary bold">
                $ {{ pricings.monthly.dynamic }} / {{ $t('select_plan_modal.month') }}
              </div>
            </div>
          </div>
          <div class="plan-badge qrw-label-md selected" v-if="selectedPlan == 'dynamic'">
            {{ $t('select_plan_modal.selected') }}
          </div>
          <div class="plan-badge qrw-label-md" @click="selectPlan('dynamic')" v-else>
            {{ $t('select_plan_modal.select') }}
          </div>
        </div>
        <div class="plan-container">
          <div class="plan-hot hidden">
            <BaseIcon icon="fire-filled" size="sm2" />
            <div class="qrw-label-md bold">
              {{ $t('select_plan_modal.most_popular') }}
            </div>
          </div>
          <div class="plan-card smart" @click="selectPlan('smart')" :class="{
    selected: selectedPlan === 'smart'
  }">
            <div class="plan-card-body">
              <div class="plan-title qrw-text-content-base-inverse-primary qrw-heading-sm bold">
                Smart {{ $t('select_plan_modal.plan') }}
              </div>
              <div class="qrw-paragraph-lg qrw-text-content-base-inverse-tertiary">
                {{ $t('select_plan_modal.smart_desc') }}
              </div>
            </div>
            <div class="plan-card-footer" v-if="selectedPeriodicity == 'yearly'">
              <div class="qrw-heading-sm bold qrw-text-content-base-inverse-primary bold">
                $ {{ pricings.yearly.smart }} / {{ $t('select_plan_modal.year') }}
              </div>
              <div class="qrw-label-lg qrw-text-content-base-inverse-tertiary">
                $ {{ pricings.monthly.smart }} / {{ $t('select_plan_modal.month') }}
              </div>
            </div>
            <div class="plan-card-footer" v-else>
              <div class="qrw-heading-sm qrw-text-content-base-inverse-primary bold">
                $ {{ pricings.monthly.smart }} / {{ $t('select_plan_modal.month') }}
              </div>
            </div>
          </div>
          <div class="plan-badge qrw-label-md selected" v-if="selectedPlan == 'smart'">
            {{ $t('select_plan_modal.selected') }}
          </div>
          <div class="plan-badge qrw-label-md" @click="selectPlan('smart')" v-else>
            {{ $t('select_plan_modal.select') }}
          </div>
        </div>

      </div>
    </div>

    <template #footer>
      <div class="plans-footer">
        <div class="qrw-label-sm qrw-text-content-warning-primary" v-if="hasAutoPayment">
          {{ $t('select_plan_modal.autocancel_hint') }}
        </div>
        <div class="gap-column-sm">
          <div class="gap-row-1xs w-100">
            <div class="qrw-label-sm bold qrw-text-content-base-tertiary">
              {{ $t('select_plan_modal.summary') }}
            </div>
            <div class="gap-column-zero qrw-text-content-base-primary">
              <div class="qrw-label-lg bold">
                {{ selectedPlanName }} {{ $t('select_plan_modal.plan') }}
              </div>
              <BaseIcon icon="dot" class="qrw-text-content-base-tertiary" size="sm2" />
              <div class="qrw-label-lg bold">
                $ {{ totalPlanPrice }}
              </div>
              <BaseIcon icon="dot" class="qrw-text-content-base-tertiary" size="sm2" />
              <div class="qrw-label-lg bold">
                {{ $t('pay_invoice_modal.' + selectedPeriodicity) }}
              </div>
            </div>
          </div>
          <div class="gap-column-xs w-100">
            <BasePushButton @click="$emit('close')" size="lg" variant="outlined" class="w-100"
              borderColor="border-base-tertiary" textColor="content-base-primary">
              {{ $t('select_plan_modal.cancel') }}
            </BasePushButton>
            <BasePushButton @click="confirmPlan" size="lg" variant="fill" :disabled="totalPlanPrice <= 0" class="w-100"
              bgColor="background-success-default" textColor="content-base-inverse-primary">
              {{ $t('select_plan_modal.confirm') }}
            </BasePushButton>
          </div>
        </div>

      </div>

    </template>
  </BaseSimpleModal>
</template>

<script>
export default {
  data () {
    return {
      selectedPeriodicity: 'monthly',
      selectedPlan: 'dynamic',
      dynamicConfig: {
        inside: true,
        takeaway: false,
        delivery: false
      }
    }
  },
  methods: {
    confirmPlan () {
      this.$emit('confirm', {
        plan: this.selectedPlan,
        periodicity: this.selectedPeriodicity,
        services: Object.keys(this.dynamicConfig).filter(k => this.dynamicConfig[k])
      })
      this.$emit('close')
    },
    selectPlan (newPlan) {
      this.selectedPlan = newPlan
    }
  },
  computed: {
    totalPlanPrice () {
      return this.pricings[this.selectedPeriodicity][this.selectedPlan]
    },

    selectedPlanName () {
      return this.selectedPlan.substring(0, 1).toUpperCase() + this.selectedPlan.substring(1)
    },

    selectedServicesCount () {
      return Object.values(this.dynamicConfig).filter(Boolean).length
    },

    hasAutoPayment () {
      return this.$store.state.cafe.billing.auto_payment_enabled;
    },

    pricings () {
      let dynamicPrice = 0
      const basePricings = {
        monthly: {
          lite: 10,
          smart: 50
        },
        yearly: {
          lite: Math.round(10 * 12 * 0.8),
          smart: 480
        },
        services: {
          inside: 25,
          delivery: 20,
          takeaway: 15
        }
      }

      for (const key in this.dynamicConfig) {
        if (this.dynamicConfig[key]) {
          dynamicPrice += basePricings.services[key]
        }
      }

      basePricings.monthly.dynamic = dynamicPrice
      basePricings.yearly.dynamic = Math.round(dynamicPrice * 12 * 0.8)

      return basePricings
    }
  }
}
</script>

<style scoped>
.plans-header {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  justify-content: center;
  align-items: center;
}

.plans {
  display: flex;
  flex-direction: row;
  column-gap: 24px;
}

.plan-container {
  display: flex;
  flex-direction: column;

  position: relative;
  width: 100%;
}

.plan-card {
  display: flex;
  flex-direction: column;

  border-radius: 12px;

  height: fit-content;

  box-shadow: var(--qrw-shadow-card-hard);

  outline: transparent solid 2px;

  flex: 1;

  position: relative;
  z-index: 1;

  cursor: pointer;
}

.plan-card.selected {
  /* border: 2px solid var(--qrw-border-success-primary); */
  outline: var(--qrw-border-success-primary) solid 2px;
}

.plan-card-body {
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  height: 100%;
  border-radius: 12px;

  background: var(--qrw-background-base-primary);
}

.plan-title {
  border-bottom: 2px solid var(--qrw-border-base-tertiary);
  padding-bottom: 8px;
  width: fit-content;
}

.plan-card-footer {
  padding: 16px 24px;
  background: var(--qrw-background-base-tertiary);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 12px 12px;
}

.plans-header-titles {
  display: flex;
  align-items: center;
  justify-content: center;
  row-gap: 16px;
  flex-direction: column;
}

.plan-badge {
  display: flex;
  justify-content: center;
  padding: 20px 16px 8px 16px;
  box-sizing: border-box;
  border-radius: 0 0 12px 12px;
  background: var(--qrw-background-base-tertiary);
  color: var(--qrw-content-base-tertiary);

  position: relative;
  z-index: 0;
  top: -16px;

  cursor: pointer;

  width: fit-content;
}

.plan-hot {
  display: flex;
  justify-content: center;
  padding: 8px 16px 20px 16px;
  box-sizing: border-box;
  border-radius: 12px 12px 0 0;
  background: var(--qrw-background-warning-secondary);
  color: var(--qrw-content-warning-primary);
  column-gap: 6px;

  position: relative;
  z-index: 0;
  top: 16px;

  width: 100%;
}

.plan-hot.hidden {
  visibility: hidden;
}

.plan-badge.selected {
  background: var(--qrw-background-success-default);
  color: var(--qrw-content-base-inverse-primary);
}

.dynamic-config {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 24px;
  box-sizing: border-box;
}

.config-row {
  display: flex;
  flex-direction: row;
  column-gap: 24px;
  align-items: center;
}

.config-row-title {
  display: flex;
  padding: 2px 0;
  width: fit-content;
  white-space: nowrap;
}

.plan-card.smart {
  background: var(--qrw-background-base-inverse-primary);
  color: var(--qrw-content-base-tertiary);
}

.plan-card.smart .plan-title {
  color: var(--qrw-content-base-inverse-primary);
  border-bottom: 2px solid var(--qrw-border-base-inverse-tertiary);
}

.plan-card.smart .plan-card-body {
  background: var(--qrw-background-base-inverse-primary);
  color: var(--qrw-content-base-tertiary);
}

.plan-card.smart .plan-card-footer {
  background: var(--qrw-background-base-inverse-tertiary);
  color: var(--qrw-content-base-inverse-primary);
}

.plan-card.selected .plan-title {
  border-color: var(--qrw-content-base-primary);
}

.plan-card.selected.smart .plan-title {
  border-color: var(--qrw-border-base-inverse-primary);
}

.plans-footer {
  display: flex;
  flex-direction: column;
  background: var(--qrw-background-base-tertiary);
  border-top: 1px solid var(--qrw-border-base-tertiary);
  padding: 24px;
  border-radius: 0 0 12px 12px;
  row-gap: 16px;
}

.plans-content {
  padding: 40px;
  row-gap: 40px;
  display: flex;
  flex-direction: column;
}
</style>

<style>
.select-plan-modal-body {
  padding: 0;
  display: flex;
  row-gap: 0;
  flex-direction: column;
}

.select-plan-modal {
  /* width: calc(100vw - 80px * 2) !important;
  height: calc(100vh - 80px * 2) !important; */

  max-width: calc(100vw - 80px * 2) !important;
  max-height: calc(100vh - 80px * 2) !important;
}
</style>